import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select, { Async, Creatable } from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
// import { spmfcloudFunctionUrl, getApplicationField, getPersonField, spmfcloudPostalFunctionUrl } from '../../actions/salesforces';
// import { q_SCHOLL_LIST, q_POSTAL_CODE_RECORD, q_POSTAL_CODE_RECORD_CONDT } from '../../actions/query';
import { regexValidate, validateNRIC } from '../../utils/common';
import '../../assets/css/form-style.css';
import { countryList } from '../../utils/constants';
import { getPostaCodeOptions } from '../Portal/actions/common';

class Tab2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renewalApplication: props.user.loggedInUser ? (props.user.loggedInUser.Partner_Authority__c === null) : false,
            dob: null,
            postal_code: [],
            selectedIdType: '',
            selectedPC: {},
            selectedAddress: {
                Street__c: '',
                Block__c: '',
                Contry__c: '',
            },
            otherMS: false,
            otherNation: false,
            otherRace: false,
            otherTF: false,
            msList: [],
            flatTypeList: this.props.data.flatTypeList,
            selectedMS: this.props.data.Marital_Status__c,
            nationList: [],
            selectedNation: {},
            selectedRace: '',
            selectedGender: '',
            selectedFlatType: {},
            maxLengthId: 9,
        };
        this.onInputChanged = this.onInputChanged.bind(this);
        this.onDOBChanged = this.onDOBChanged.bind(this);
        this.onAddressChanged = this.onAddressChanged.bind(this);
        this.onMaritalStatusChanged = this.onMaritalStatusChanged.bind(this);
        this.onNationalityChanged = this.onNationalityChanged.bind(this);
        this.onFlatTypeChanged = this.onFlatTypeChanged.bind(this);

        // this.getPostaCodeOptions = this.getPostaCodeOptions.bind(this);
        this.onPostalCodeChanges = this.onPostalCodeChanges.bind(this);
    }

    componentWillMount() {
        this.setState({
            selectedGender: this.props.data.Gender__c,
            dob: this.props.data.Date_of_Birth__c ? moment(this.props.data.Date_of_Birth__c) : '',
            selectedMS: this.props.data.Marital_Status__c,
            selectedRace: this.props.data.Race__c,
            selectedFlatType: {
                active: true,
                defaultValue: false,
                label: this.props.data.Flat_Type__c,
                validFor: null,
                value: this.props.data.Flat_Type__c,
            },
            selectedPC: {
                value: this.props.data.Postal__c,
                label: this.props.data.Postal__c,
                type: 'new_postal',
            },
        });
    }

    componentDidMount() {
        const postalCodeOption = [];
        if (this.props.salesforce.postalCodeRecord.fields.records === undefined) return;
        this.props.salesforce.postalCodeRecord.fields.records.map((pc_list, idx) => {
            postalCodeOption.push({
                type: 'postal_code',
                key: idx,
                value: pc_list.Name,
                label: pc_list.Name,
            });
        });
        this.state.postal_code = postalCodeOption;
        this.validateNricFunc(this.props.data.ID_Number__c);
        // this.forceUpdate();
    }

    componentWillReceiveProps(nextProps) {
        /* if (this.state.renewalApplication) {
            if (Object.keys(this.state.selectedFlatType).length === 0 && nextProps.salesforce.applicationInfo.data.records.length > 0) {
                this.onFlatTypeChanged({
                    active: true, defaultValue: false, label: nextProps.salesforce.applicationInfo.data.records[0].Application__r.Flat_Type__c, validFor: null, value: nextProps.salesforce.applicationInfo.data.records[0].Application__r.Flat_Type__c,
                });
                this.onPostalCodeChanges({ value: nextProps.salesforce.applicationInfo.data.records[0].Application__r.Postal__c, label: nextProps.salesforce.applicationInfo.data.records[0].Application__r.Postal__c, type: 'new_postal' });
                if (nextProps.salesforce.applicationInfo.data.records[0].Application__r.Street__c != '') {
                    this.props.changeState('Street__c', nextProps.salesforce.applicationInfo.data.records[0].Application__r.Street__c);
                }
                if (nextProps.salesforce.applicationInfo.data.records[0].Application__r.Unit_Number__c != '') {
                    this.props.changeState('Unit_Number__c', nextProps.salesforce.applicationInfo.data.records[0].Application__r.Unit_Number__c);
                }
                if (nextProps.salesforce.applicationInfo.data.records[0].Application__r.Block__c != '' && nextProps.salesforce.applicationInfo.data.records[0].Application__r.Block__c != null) {
                    console.log('event fired to 2');

                    this.props.changeState('Block__c', nextProps.salesforce.applicationInfo.data.records[0].Application__r.Block__c);
                }
                if (nextProps.salesforce.applicationInfo.data.records[0].ID_Number__c != '' && nextProps.salesforce.applicationInfo.data.records[0].ID_Number__c != null) {
                    this.props.changeState('ID_Number__c', nextProps.salesforce.applicationInfo.data.records[0].ID_Number__c);
                    this.validateNricFunc(nextProps.salesforce.applicationInfo.data.records[0].ID_Number__c);
                }
                this.props.changeState('Country__c', 'Singapore');
            }
        } */

        this.validateNricFunc(nextProps.data.ID_Number__c);
        this.setState({
            selectedGender: nextProps.data.Gender__c,
            dob: nextProps.data.Date_of_Birth__c ? moment(nextProps.data.Date_of_Birth__c) : '',
            selectedMS: nextProps.data.Marital_Status__c,
            selectedRace: nextProps.data.Race__c,
            selectedFlatType: {
                active: true,
                defaultValue: false,
                label: this.props.data.Flat_Type__c,
                validFor: null,
                value: this.props.data.Flat_Type__c,
            },
            selectedPC: {
                value: this.props.data.Postal__c,
                label: this.props.data.Postal__c,
                type: 'new_postal',
            },
        });
    }

    onMaritalStatusChanged(selectedMS) {
        if (selectedMS == null) {
            this.props.changeState('Marital_Status__c', '');
            this.setState({ selectedMS: {} });
        } else {
            if (selectedMS.value === 'Others') {
                this.setState({ otherMS: true });
            } else {
                this.setState({ otherMS: false });
                this.props.changeState('Other_Marital_Status__c', '');
            }
            this.props.changeState('Marital_Status__c', selectedMS.value);
            this.setState({ selectedMS });
        }
    }

    onNationalityChanged(selectedNation) {
        if (selectedNation == null) {
            this.props.changeState('Nationality__c', '');
            this.setState({ selectedNation: {} });
        } else {
            if (selectedNation.value === 'Others') {
                this.props.data.ID_Type__c = 'FIN';
                this.setState({ otherNation: true });
            } else {
                this.props.data.ID_Type__c = 'NRIC';
                this.setState({ otherNation: false });
                this.props.changeState('Other_Nationality__c', '');
            }
            this.props.changeState('Nationality__c', selectedNation.value);
            this.setState({ selectedNation });
        }
    }

    onFlatTypeChanged(selectedFlatType) {
        if (selectedFlatType == null) {
            this.props.changeState(['Flat_Type__c'], '');
            this.setState({ selectedFlatType: {} }, () => this.setState({ selectedFlatType: {} }));
        } else {
            if (selectedFlatType.value == 'Others') {
                this.setState({ otherTF: true });
            } else {
                this.setState({ otherTF: false });
                this.props.changeState('Other_Flat_Type__c', '');
            }
            this.setState({ selectedFlatType }, () => this.setState({ selectedFlatType }));
            this.props.changeState(['Flat_Type__c'], selectedFlatType.value);
        }
    }


    onAddressChanged(evt) {
        const target = `{ "${evt.target.id}":"${evt.target.value}" }`;
        const update = require('react-addons-update');
        const newData = update(this.state.selectedAddress, { $merge: JSON.parse(target) });
        this.setState({ selectedAddress: newData });

        this.props.changeState([evt.target.name], evt.target.value);
    }


    onInputChanged(evt) {
        let { value } = evt.target;
        if (evt.target.id === 'Gender__c') {
            this.setState({
                selectedGender: value,
            });
        }

        if (evt.target.id === 'Race__c') {
            if (value === 'Others') {
                this.setState({ otherRace: true, selectedRace: value });
            } else {
                this.setState({ otherRace: false, selectedRace: value });
                this.props.changeState(['Other_Race__c'], '');
            }
        }
        if (evt.target.name.indexOf('Email') !== -1) {
            const isValidEmail = value !== '' ? regexValidate('email', value) : true;
            if (!isValidEmail) {
                document.getElementById('email_error').innerHTML = 'invalid email format';
            } else {
                document.getElementById('email_error').innerHTML = '';
            }
            this.props.data.isValidMainEmail = isValidEmail;
        }
        if (evt.target.name === 'ID_Type__c') {
            if (evt.target.value === 'Others') {
                this.props.data.Nationality__c = 'Others';
                this.setState({ maxLengthId: 30, otherNation: true });
                document.getElementById('nric_error').innerHTML = '';
            } else {
                if (evt.target.value === 'FIN') {
                    this.props.data.Nationality__c = 'Others';
                } else {
                    this.props.data.Nationality__c = 'Singaporean';
                }
                if (document.getElementById('ID_Number__c').value !== '') {
                    if (!validateNRIC(document.getElementById('ID_Number__c').value)) {
                        document.getElementById('nric_error').innerHTML = 'invalid NRIC/FIN format';
                    }
                }
            }
        }
        if (evt.target.name === 'ID_Number__c') {
            value = value.toUpperCase();

            if (this.props.data.ID_Type__c !== 'Others') {
                this.validateNricFunc(value);
            }
        }
        if (['Contact_Number__c', 'Home_Phone__c', 'Mobile_Phone__c', 'Office_Number__c'].indexOf(evt.target.name) > -1) {
            if (/^[0-9]*$/ig.test(evt.target.value) === false) return;
        }
        this.props.changeState([evt.target.name], value);
    }

    onDOBChanged(date) {
        if (moment() < date) {
            swal({
                type: 'warning',
                title: 'Invalid Date of Birth!',
                text: 'Date of birth can\'t be future date.',
            });
        } else {
            this.props.changeState('Date_of_Birth__c', date.format('YYYY-MM-DD').toString());
            this.setState({
                dob: date,
            });
        }
    }

    onPostalCodeChanges(selectedPC) {
        this.props.changeState('Postal__c', selectedPC.value);
        this.props.changeState('Street__c', selectedPC.STREETNAME);
        this.props.changeState('Block__c', selectedPC.BLDGNO);
        this.props.changeState('Country__c', 'Singapore');

        // Set state twice because somehow just do it once doesn't actually update it
        this.setState({ selectedPC }, () => this.setState({ selectedPC }) );
    }

    // common function
    validateNricFunc(value) {
        if (document.getElementById('ID_Type__c').value === 'NRIC' || document.getElementById('ID_Type__c').value === 'FIN') {
            const isValidId = validateNRIC(value);
            if (!isValidId) {
                document.getElementById('nric_error').innerHTML = 'invalid NRIC/FIN format';
            } else {
                document.getElementById('nric_error').innerHTML = '';
            }
            this.props.data.isValidMainNric = isValidId;
        } else {
            this.props.data.isValidMainNric = true;
        }
    }

    inputChangeHandler(event) {
        // this.setState({ [event.target.name]: event.target.value });
        this.props.changeState([event.target.name], event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    }


    render() {
        const loadPostCodeList = async (input, callback) => {
            try {
                const url = `${apiConfig.url}/api/getPostalCode/${input || 0}`;
                const json = await fetch(url, {
                    mode: 'cors',
                    cache: 'no-cache',
                    headers: {
                        origin: 'http://localhost:8080',
                    },
                    method: 'GET',
                }).then(response => response.json());

                let options = [{ value: input, label: input, type: 'new_postal' }];

                if (json.data) {
                    options = [
                        {
                            value: json.data.POSTCODE,
                            label: json.data.POSTCODE,
                            Street__c: json.data.STREETNAME,
                            Building_Name__c: json.data.BLDGNAME,
                            Block__c: json.data.BLDGNO,
                            Country__c: 'Singapore',
                        },
                    ];
                }

                callback(null, {
                    options,
                    complete: true,
                });

                return { options };
            } catch (err) {
                console.error(err, input);
            }
        };

        return (
            <div className="col-md-12 print">
                <div className="row">
                    <br />
                    <h4 className="info-text">Personal Details</h4>
                    <br />
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Full Name in NRIC <small style={{ color: 'red' }}>(required)</small></label>
                            <input name="Full_Name__c" id="Full_Name__c" type="text" className="form-control" value={this.props.data.Full_Name__c} onChange={this.onInputChanged} />
                        </div>
                        <div className="form-group">
                            <label>ID Type <small className="red">(required)</small></label>
                            <select
                                id="ID_Type__c"
                                name="ID_Type__c"
                                className="form-control valid select"
                                aria-invalid="false"
                                value={this.props.data.ID_Type__c}
                                onChange={this.onInputChanged}
                            >
                                {this.props.data.IDTypeList !== undefined &&
                                    this.props.data.IDTypeList.map(option => (
                                        <option key={shortid.generate()} value={option.value} className="white">{option.label}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="form-group">
                            <label>ID Number <small style={{ color: 'red' }}>(required)</small></label>
                            <input
                                name="ID_Number__c"
                                id="ID_Number__c"
                                type="text"
                                className="form-control"
                                value={this.props.data.ID_Number__c}
                                maxLength={this.state.maxLengthId}
                                onChange={this.onInputChanged}
                                placeholder="NRIC e.g. S9268776G"
                            />
                            <span id="nric_error" style={{ color: 'red' }} />
                        </div>
                        <div className="form-group">
                            <label>Date of Birth <small className="red">(required)</small></label>
                            <DatePicker
                                name="Date_of_Birth__c"
                                selected={this.state.dob}
                                dateFormat="DD/MM/YYYY"
                                onChange={this.onDOBChanged}
                                className="form-control fullw"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />
                        </div>
                        <div className="form-group">
                            <label>Marital Status <small className="red">(required)</small></label>
                            <Select
                                name="Marital_Status__c"
                                ref="Marital_Status__c"
                                id="Marital_Status__c"
                                onChange={this.onMaritalStatusChanged}
                                options={this.props.data.msList}
                                value={this.state.selectedMS}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Other Marital Status</label>
                            <input
                                name="Other_Marital_Status__c"
                                type="text"
                                value={this.props.data.Other_Marital_Status__c}
                                onChange={this.onInputChanged}
                                className="form-control"
                                disabled={!this.state.otherMS}
                            />
                        </div>

                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Gender <small className="red">(required)</small></label>
                            <select
                                name="Gender__c"
                                id="Gender__c"
                                className="form-control valid select"
                                aria-invalid="false"
                                onChange={this.onInputChanged}
                                value={this.state.selectedGender}
                            >
                                <option value="" />
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Nationality <small className="red">(required)</small></label>
                            <Select
                                name="Nationality__c"
                                ref="Nationality__c"
                                id="Nationality__c"
                                onChange={this.onNationalityChanged}
                                options={this.props.data.nationList}
                                value={this.props.data.Nationality__c}
                                required
                            />
                        </div>
                        <div className="form-group" >
                            <label>Other Nationality</label>
                            <input
                                name="Other_Nationality__c"
                                type="text"
                                className="form-control"
                                value={this.props.data.Other_Nationality__c}
                                onChange={this.onInputChanged}
                                disabled={!this.state.otherNation}
                            />
                        </div>
                        <div className="form-group">
                            <label>Race <small className="red">(required)</small></label>
                            <select
                                id="Race__c"
                                name="Race__c"
                                className="form-control valid select"
                                aria-invalid="false"
                                onChange={this.onInputChanged}
                                value={this.state.selectedRace}
                            >
                                <option value="" className="white" />
                                {this.props.data.raceList !== undefined &&
                                    this.props.data.raceList.map(option => (
                                        <option key={shortid.generate()} value={option.value}>{option.label}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Other Race</label>
                            <input
                                name="Other_Race__c"
                                type="text"
                                className="form-control"
                                value={this.props.data.Other_Race__c}
                                onChange={this.onInputChanged}
                                disabled={!this.state.otherRace}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <br />
                    <h4 className="info-text">Address</h4>
                    <br />
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Postal Code <small className="red">(required)</small></label>
                            {/* <input type="text" name="City__c" id="City__c" className="form-control" placeholder="Please Select Postal Code..." /> */}
                            {/* <Select
                                name="Postal__c"
                                ref="postal_code"
                                id="postalCode"
                                onChange={this.pc_handleChange}
                                onInputChange={(input)=>{this.pc_handleChange({type:'userinput' ,label: input, value: input})}}
                                options={this.state.postal_code}
                                value={this.state.selectedPC}
                                required /> */}
                            <Async
                                name="postalCode"
                                id="Postal__c"
                                value={this.state.selectedPC}
                                loadOptions={getPostaCodeOptions}
                                onChange={this.onPostalCodeChanges}
                            />
                        </div>
                        <div className="form-group">
                            <label>Street Name <small className="red">(required)</small></label>
                            <input
                                id="Street__c"
                                name="Street__c"
                                type="text"
                                className="form-control"
                                value={this.state.renewalApplication ? this.props.salesforce.applicationInfo != undefined ? this.props.salesforce.applicationInfo.data != undefined ? this.props.salesforce.applicationInfo.data.records.length > 0 ? this.props.salesforce.applicationInfo.data.records[0].Application__r.Street__c : '' : '' : '' : this.props.data.Street__c}
                                onChange={this.onAddressChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label>Block Number <small className="red">(required)</small></label>
                            <input
                                id="Block__c"
                                name="Block__c"
                                type="text"
                                className="form-control"
                                placeholder="Put NA if not applicable"
                                value={this.state.renewalApplication ? this.props.salesforce.applicationInfo != undefined ?
                                    this.props.salesforce.applicationInfo.data != undefined ? this.props.salesforce.applicationInfo.data.records.length > 0 ? this.props.salesforce.applicationInfo.data.records[0].Application__r.Block__c : '' : '' : '' : this.props.data.Block__c}
                                onChange={this.onAddressChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label>Unit Number/House Number <small className="red">(required)</small></label>
                            <input
                                id="Unit_Number__c"
                                name="Unit_Number__c"
                                type="text"
                                className="form-control"
                                value={this.state.renewalApplication ? this.props.salesforce.applicationInfo != undefined ?
                                    this.props.salesforce.applicationInfo.data != undefined ? this.props.salesforce.applicationInfo.data.records.length > 0 ? this.props.salesforce.applicationInfo.data.records[0].Application__r.Unit_Number__c : '' : '' : '' : this.props.data.Unit_Number__c}
                                onChange={this.onInputChanged}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Type of Flat <small className="red">(required)</small></label>
                            <Select
                                id="Flat_Type__c"
                                name="Flat_Type__c"
                                aria-invalid="false"
                                options={this.props.data.flatTypeList}
                                value={this.state.selectedFlatType}
                                onChange={this.onFlatTypeChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label>Specify Other HDB Flat Types</label>
                            <input
                                name="Other_Flat_Type__c"
                                type="text"
                                className="form-control"
                                value={this.state.renewalApplication ? this.props.salesforce.applicationInfo != undefined ?
                                    this.props.salesforce.applicationInfo.data != undefined ? this.props.salesforce.applicationInfo.data.records.length > 0 ? this.props.salesforce.applicationInfo.data.records[0].Application__r.Other_Flat_type__c : '' : '' : '' : this.props.data.Other_Flat_Type__c}
                                onChange={this.onInputChanged}
                                disabled={!this.state.otherTF}
                            />
                        </div>

                        <div className="form-group">
                            <label>Country <small style={{ color: 'red' }}>(required)</small></label><br />
                            <select
                                className="form-control"
                                name="Country__c"
                                onChange={this.onInputChanged}
                                value={this.props.data.Country__c}
                            >
                                {countryList.map(country => <option key={shortid.generate()} value={country}>{country}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <br />
                    <h4 className="info-text">Personal Contact</h4>
                    <br />
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Contact Number <small style={{ color: 'red' }}>(required)</small></label>
                            <input
                                name="Contact_Number__c"
                                id="Contact_Number__c"
                                type="text"
                                value={this.props.data.Contact_Number__c}
                                className="form-control"
                                onChange={this.onInputChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label>Mobile Phone  <small style={{ color: 'red' }}>(required)</small></label>
                            <input
                                name="Mobile_Phone__c"
                                id="Mobile_Phone__c"
                                value={this.props.data.Mobile_Phone__c}
                                type="tel"
                                className="form-control"
                                onChange={this.onInputChanged}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Office Phone</label>
                            <input
                                name="Office_Number__c"
                                value={this.props.data.Office_Number__c}
                                id="Office_Phone__c"
                                type="tel"
                                className="form-control"
                                onChange={this.onInputChanged}
                            />
                        </div>
                        <div className="form-group">
                            <label>Home Phone</label>
                            <input
                                name="Home_Phone__c"
                                id="Home_Phone__c"
                                value={this.props.data.Home_Phone__c}
                                type="tel"
                                className="form-control"
                                onChange={this.onInputChanged}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Email Address <small className="red">(If You wish to receive confirmation of application outcome)</small></label>
                            <input
                                name="Email_Address__c"
                                id="Email_Address__c"
                                value={this.props.data.Email_Address__c}
                                type="text"
                                className="form-control"
                                onChange={this.onInputChanged}
                            />
                            <span id="email_error" style={{ color: 'red' }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Tab2.propTypes = {
    changeState: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
};
Tab2.defaultProps = {
};


const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tab2);



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/tab2.js
// module id = 1043
// module chunks = 0